import { authorizationHeader } from '@picsart/growth-rc/services/auth';

import { SUBMIT_WEB_HOOK_URL } from '@/consts/urls';
import { ErrorMessages } from '@/consts/errors';
import { getContext } from '@/context';
import { getAccessToken } from '@/utils/user/getAccessToken';
import { showNotification } from '@/utils/ui/showNotification';

import type { NotificationConfig } from '@/types';

import { NotificationType } from '@/types';

type SubmitWebhookData = {
  status: string;
  reason: string;
  response: {
    id: string;
  };
};

type DriveOptions = {
  folderName: string;
  packageId?: string;
  attributes?: {
    category?: string;
  };
};

type Params = {
  webhookId: string;
  params: Record<string, unknown>;
  driveOptions?: DriveOptions;
  notificationConfig?: NotificationConfig;
};

const submitWebHook = async ({ notificationConfig, ...params }: Params) => {
  try {
    const response = await getContext().utils.api.fetch(SUBMIT_WEB_HOOK_URL, {
      method: 'POST',
      body: JSON.stringify({
        params,
        ...(notificationConfig && { notification: notificationConfig }),
      }),
      headers: {
        'Content-Type': 'application/json',
        ...authorizationHeader(getAccessToken()),
      },
    });

    if (!response.ok) {
      const body = await response.text().catch(() => '');
      const error = new Error(
        `Webhook submission failed: ${body || response.statusText}`
      );
      throw error;
    }

    const data: SubmitWebhookData = await response.json();

    if (!data?.response?.id) {
      throw new Error('Webhook response missing id field');
    }

    return { id: data.response.id };
  } catch (error) {
    showNotification({
      title: ErrorMessages.submitWebHook,
      type: NotificationType.ERROR,
    });
    throw error;
  }
};

export { submitWebHook };
